import product1 from "./assets/1.webp";
import product2 from "./assets/2.webp";
import product3 from "./assets/3.webp";
import product4 from "./assets/4.webp";
import product5 from "./assets/5.webp";
import product6 from "./assets/6.webp";
import product7 from "./assets/7.webp";
import product8 from "./assets/8.webp";
import product9 from "./assets/9.webp";
import product10 from "./assets/10.webp";
import product11 from "./assets/11.webp";
import product12 from "./assets/12.webp";
import product13 from "./assets/13.webp";
import product14 from "./assets/14.webp";
import product15 from "./assets/15.webp";

export const PRODUCTS = [
  {
    id: 1,
    productName: "Ganesha",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Village pro-12",
    price: 199.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Women in thought",
    price: 699.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Sea-pea spi Art",
    price: 228.29,
    productImage: product4,
  },
  {
    id: 5,
    productName: "The Mona Lisa ",
    price: 190.99,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Radha-Krishna jtzle",
    price: 680.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "God prushu GOLF WANG",
    price: 200.80,
    productImage: product7,
  },
  {
    id: 8,
    productName: "The Aswasthama Art",
    price: 540.0,
    productImage: product8,
  },
  {
    id: 9,
    productName: "The Crazy Women",
    price: 140.0,
    productImage: product9,
  },
  {
    id: 10,
    productName: "The Danger Village Bank",
    price: 189.0,
    productImage: product10,
  },
  {
    id: 11,
    productName: "The Haunted Man",
    price: 540.0,
    productImage: product11,
  },
  {
    id: 12,
    productName: "The Lotus bird",
    price: 320.0,
    productImage: product12,
  },
  {
    id: 13,
    productName: "Village Landscap",
    price: 197.0,
    productImage: product13,
  },
  {
    id: 14,
    productName: "Corona And Women",
    price: 160.0,
    productImage: product14,
  },
  {
    id: 15,
    productName: "The Approching Hand",
    price: 180.0,
    productImage: product15,
  },
];
